class FeaturedCollectionTabs extends HTMLElement {
  connectedCallback() {
    this.tablist = this.querySelector('[role="tablist"]');
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => this.activate(event.currentTarget));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });
  }

  activate(tab) {
    if (!tab || tab.getAttribute('aria-selected') === 'true') return;

    this.tabs.forEach((t) => {
      const active = t === tab;
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
      t.classList.toggle('featured-collection-tabs__tab--active', active);
    });

    const panelId = tab.getAttribute('aria-controls');
    this.panels.forEach((panel) => {
      if (panel.id === panelId) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  onKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    if (currentIndex === -1) return;

    let nextIndex = null;
    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    const nextTab = this.tabs[nextIndex];
    nextTab.focus();
    this.activate(nextTab);
  }
}

customElements.define('featured-collection-tabs', FeaturedCollectionTabs);
